import { styled } from "@mui/system";
import { Collapse } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledAnomaliesViewer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  overflow: auto;
`;

export const StyledAnomaliesViewerContent = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
